---
title: 'Step 4: Configure the Collector'
install_track_title: Installation Guide (Neon)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'

export const APIKeyInstructions = ({ apiKey }) => {
  return apiKey ? (
    <React.Fragment>
      The <code>api_key</code> for the current organization is{" "}
      <code>{apiKey}</code>
    </React.Fragment>
  ) : (
    <React.Fragment>
      The <code>api_key</code> can be found in the pganalyze Settings page for
      your organization, under the API Access tab
    </React.Fragment>
  );
};

export const ConfigSample = ({ apiKey }) => {
  return (
    <CodeBlock language="ini">
      {`[pganalyze]
api_key = ${apiKey ?? 'your_pga_organization_api_key'}\n
[server1]
db_host = ep-your-endpoint-id.your-region.aws.neon.tech
db_name = your_database_name
db_username = pganalyze
db_password = your_monitoring_user_password
db_sslmode = require`}
    </CodeBlock>
  )
}

The collector configuration file lives in `/etc/pganalyze-collector.conf`, and looks like this:

<ConfigSample apiKey={props.apiKey} />

Fill in the values step-by-step:

1. <APIKeyInstructions apiKey={props.apiKey} />
2. The `db_host` is the compute endpoint hostname for the branch you want to monitor,
   of the form `ep-<endpoint-id>.<region>.aws.neon.tech`. You can copy the full
   connection string from the **Connect** dialog in the Neon Console for the branch
   in question
3. The `db_name` is the database on that branch you want to monitor
4. The `db_username` and `db_password` should be the credentials of the monitoring user
   we created in Step 1

The collector automatically detects that this is a Neon branch from the `db_host` suffix
(`.neon.tech`), so no further platform-specific configuration is required. Note that Neon
doesn't expose host-level system metrics (CPU, memory, disk) through an API the collector
can use, so pganalyze will show query and schema statistics for your branch, but not the
System Overview metrics available for other platforms.

## Testing the new configuration

Run the following to make sure the configuration works:

```bash
sudo pganalyze-collector --test
```

<PublicLastStepLogInsightsLink />
